'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import Image from 'next/image';
import { Typography } from '@components/typography';
import { Carousel } from '../../_home/value-section/carousel';
import quotationMarkSvg from '../../../../../public/assets/svg/list/quotation_mark.svg';
const testimonials = [{
  body: "We've reduced our overall commission costs by 12% while maintaining the same booking volume. The direct PMS integration means zero extra work for our team.",
  author: {
    name: 'Robert Williams',
    company: 'Midwest Luxury Vacation Rentals',
    numberOfProperties: 224
  }
}, {
  body: 'Working with the team at Savvy was a pleasure. The onboarding process was easy and seamless and my properties were live quickly on their platform. Their business model of allowing the host to control the guest relationship is refreshing and builds immediate trust.',
  author: {
    name: 'Jeff Harris',
    company: 'Casago Heber',
    numberOfProperties: 9
  }
}, {
  body: 'For folks who are over high fees on vacation rental bookings Savvy is a great solution. No extra cost for the traveler, super sweet! And for hosts... are you getting as much exposure to a saturated market as you could be? Savvy will help you get your brand noticed!',
  author: {
    name: 'Nancy Aurand',
    company: 'Awesome Vacation Homes, Inc.',
    numberOfProperties: 18
  }
}, {
  body: "We got our first booking from Savvy on a last minute booking for NYE last week. I was really excited to see that, as we couldn't get it booked on the other bigger platforms!",
  author: {
    name: 'John Clanton',
    company: 'King Rentals Property Management',
    numberOfProperties: 102
  }
}, {
  body: 'The onboarding took literally 10 minutes.',
  author: {
    name: 'Steven Taormina',
    company: 'Greenday Vacation Rentals',
    numberOfProperties: 35
  }
}];
export const TestimonialSection: React.FC = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Typography variant="title5" component="h2" className="text-primary-main !text-lg sm:!text-xl tracking-wide">What Property Managers Are Saying</Typography>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center justify-center mt-6"><Image src={quotationMarkSvg} alt="Quotation Mark" width={50} height={50} /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="bg-off-white w-full"><div className="max-w-5xl mx-auto px-4 sm:px-8 py-12 sm:py-16 text-center">{t0}{t1}<Carousel showDots={true} showArrows={false} className="mx-auto max-w-4xl" useAspectRatio={false} autoHeight={true} brandColorDots={true}>{testimonials.map(_temp)}</Carousel></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
function _temp(testimonial) {
  return <div key={testimonial.author.name} className="flex items-center justify-center"><div className="flex w-full flex-col items-center justify-center px-4 py-8 sm:px-8 sm:py-10"><Typography component="p" variant="title4" className="text-primary-main !text-xl sm:!text-2xl md:!text-3xl lg:!text-[2rem] leading-relaxed !font-normal max-w-3xl">{testimonial.body}</Typography><div className="flex items-center gap-3 pt-8 text-center"><Typography component="span" variant="body2" className="text-primary-main !font-semibold !text-sm">{testimonial.author.name}</Typography><span className="text-primary-main/30">|</span><Typography component="span" variant="body2" className="text-primary-main !text-sm">{testimonial.author.company}</Typography>{testimonial.author.numberOfProperties && <><span className="text-primary-main/30">|</span><Typography component="span" variant="body2" className="text-primary-main !text-sm">{testimonial.author.numberOfProperties} Properties</Typography></>}</div></div></div>;
}